import React from 'react';
/*ui*/
import Typography from "@material-ui/core/Typography";
/*component*/
import toLocale from "../../../helpers/toLocale";


const searchAccPrice = (accData, classes) => {
    if (!accData.base_price) return;

    if (!accData.final_price || accData.final_price === accData.base_price) {
        return `${toLocale(accData.base_price)}€ <span className={classes.tva}>TVA <br />inclus</span>`
    } else {
        return (
            <React.Fragment>
                <div>{toLocale(accData.final_price)}€ <span className={classes.tva}>TVA <br />inclus</span>
                    <Typography variant="caption"
                        className={classes.oldPrice}>{toLocale(accData.base_price)}€</Typography> <span className={classes.tva}>TVA <br />inclus</span></div>
            </React.Fragment>
        )
    }
}

export default searchAccPrice;
